import { FC } from 'react';
import styled from '@emotion/styled';
import Started from '@cont/SeeAll/TestSeriesListing/DailyScholarshipTest/Started';
import {
  DST as DSTType,
  DST_STATES
} from '@cont/SeeAll/TestSeriesListing/DailyScholarshipTest/utils';
import Result from '@cont/SeeAll/TestSeriesListing/DailyScholarshipTest/Result';
import { mediaQuery } from '@styles/index';
import useDstClickHandlers from '@cont/SeeAll/TestSeriesListing/DailyScholarshipTest/useDstClickHandlers';
import DSTMobile from './DSTMobile';
import DSTTablet from './DSTTablet';
import Unattempted from './Unattempted';

const Container = styled.div`
  position: relative;
  width: 1136px;
  top: -47px;
  margin: auto auto 30px;

  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;

type DSTProps = {
  block: DSTType;
  goalUID: string;
  goalSlug: string;
  goalDetails: any;
};

const DST: FC<DSTProps> = ({
  block: data,
  goalUID,
  goalSlug,
  goalDetails: { name: goalName = '' } = {}
}) => {
  const { state } = data.data[0];

  const { takeTest } = useDstClickHandlers({
    goalUID,
    goalSlug,
    goalName,
    lps: 'Home'
  });

  if (state === DST_STATES.UNATTEMPTED) {
    return (
      <>
        <DSTMobile data={data} takeTest={takeTest} />
        <DSTTablet data={data} takeTest={takeTest} />
        <Container>
          <Unattempted data={data} takeTest={takeTest} />
        </Container>
      </>
    );
  }

  switch (state) {
    case DST_STATES.RESUME:
    case DST_STATES.ATTEMPTED:
      return (
        <Container>
          <Started
            data={data}
            goalUID={goalUID}
            goalName={goalName}
            lps="Home"
          />
        </Container>
      );

    case DST_STATES.REATTEMPT:
    case DST_STATES.WON:
      return (
        <Container>
          <Result
            data={data}
            goalUID={goalUID}
            goalSlug={goalSlug}
            goalName={goalName}
            lps="Home"
          />
        </Container>
      );

    default:
      return null;
  }
};

export default DST;
